// Sidebar.jsx
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { FaBars, FaSignOutAlt } from "react-icons/fa";

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { to: "/", label: "🌐 Voir le site" },
    { to: "/admin/items", label: "🚗 items (Créer / Modifier)" },
    // { to: "/admin/LocationManager", label: "📦 Disponibilités Vente & Location" },
    // { to: "/admin/reservations", label: "📋 Réservations clients" },
    { to: "/admin/marques", label: "🏷️ Marques & Modèles" },
    { to: "/admin/ListeColis", label: "📦 Colis (Créer / Modifier)" },
  ];

  const handleLogout = async () => {
    const auth = getAuth();
    await signOut(auth);
    navigate("/login");
  };

  return (
    <>
      {/* Toggle Mobile */}
      <button
        className="btn btn-light d-md-none m-2 position-fixed start-0 top-0"
        onClick={() => setIsOpen(!isOpen)}
        style={{ zIndex: 1051 }}
      >
        <FaBars />
      </button>

      {/* Sidebar */}
      <div
        className={`bg-dark text-white vh-100 position-fixed top-0 start-0 shadow ${isOpen ? "d-block" : "d-none"} d-md-block`}
        style={{ width: "250px", zIndex: 1050 }}
      >
        <div className="p-3 d-flex flex-column h-100 justify-content-between">
          <div>
            <div className="d-flex align-items-center mb-4">
              <img src="/d.png" alt="Logo" width="180" className="me-2" />
            </div>

            <ul className="nav flex-column">
              {links.map((link, i) => {
                const isActive = location.pathname === link.to || location.pathname.startsWith(link.to + "/");
                return (
                  <li key={i} className="nav-item mb-1">
                    <Link
                      to={link.to}
                      className={`nav-link text-white ${isActive ? "active fw-bold bg-secondary rounded px-3 py-2" : "px-3 py-2"}`}
                      onClick={() => setIsOpen(false)}
                    >
                      {link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <button
              className="btn btn-outline-light w-100 d-flex align-items-center justify-content-center gap-2"
              onClick={() => setShowConfirm(true)}
            >
              <FaSignOutAlt /> Déconnexion
            </button>
          </div>
        </div>
      </div>

      {/* Modal Confirmation Déconnexion */}
      {showConfirm && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirmation</h5>
                <button type="button" className="btn-close" onClick={() => setShowConfirm(false)}></button>
              </div>
              <div className="modal-body">
                <p>Êtes-vous sûr de vouloir vous déconnecter ?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowConfirm(false)}>Annuler</button>
                <button className="btn btn-danger" onClick={handleLogout}>Se déconnecter</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
